import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Route } from 'react-router-dom';
import { RequirePermission } from '@marinoscar/platform-web/identity/headless';
/**
 * The `<Route>` elements of the routes a `@marinoscar/kvox-web` slice exports as
 * data (`kvoxNotesRoutes`, `kvoxGraphRoutes`, ...).
 *
 * @remarks
 * The slice declares the path, the lazy page and the permission the route is gated
 * on; this supplies the guard. A route with a `permission` is wrapped in the
 * platform's `RequirePermission`, and a viewer without it is sent to the route's
 * `redirectTo` (or `fallback`, default `/`) with `replace`. A route without one
 * renders its page directly. Call it where the literal `<Route>`s would go: the
 * order of routes is the order of the array, and the page renders inside the
 * `Suspense` boundary the host already provides around lazy pages.
 *
 * @param routes - the slice's route data, possibly several arrays concatenated.
 * @param options - see {@link RenderKvoxRoutesOptions}.
 * @returns the `<Route>` elements, keyed by path.
 *
 * @example
 * ```tsx
 * <Route element={<KvoxAppShell navigation={NAVIGATION} />}>
 *   {renderKvoxRoutes([...kvoxNotesRoutes, ...kvoxGraphRoutes])}
 * </Route>
 * ```
 *
 * @stability experimental
 */
export function renderKvoxRoutes(routes, options = {}) {
    const fallback = options.fallback ?? '/';
    return routes.map(({ path, permission, redirectTo, Component }) => (_jsx(Route, { path: path, element: permission ? (_jsx(RequirePermission, { permission: permission, fallback: _jsx(Navigate, { to: redirectTo ?? fallback, replace: true }), children: _jsx(Component, {}) })) : (_jsx(Component, {})) }, path)));
}
